/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { Button } from "@uhg-abyss/web/ui/Button";
import { LoadingOverlay } from "@uhg-abyss/web/ui/LoadingOverlay";
import { Layout } from "@uhg-abyss/web/ui/Layout";

export default function SubmissionPopup(props) {
  const renderSubmissionErrors = () => {
    const errors = [];
    props.submissionErrors.forEach((element, index) => {
      errors.push(
        <p key={index} className="text-danger">
          {element}
        </p>
      );
    });
    return errors;
  };

  return (
    <>
      {props.isOpen ? (
        <ModalDialog
          isOpen={props.isOpen}
          onClose={props.onClose}
          header={props.submissionHeader}
          footer={
            <Layout.Group alignLayout="right">
              <Button onClick={props.onClose}> Done </Button>
            </Layout.Group>
          }
        >
          <p>{props.submissionSubText}</p>
          {renderSubmissionErrors()}
        </ModalDialog>
      ) : (
        <div className="popup-background">
          <LoadingOverlay
            isLoading={true}
            loadingTitle={props.loadingTitle || "Loading..."}
            loadingMessage={props.loadingMessage}
            ariaLoadingLabel={props.ariaLoadingLabel}
          />
        </div>
      )}
    </>
  );
}

SubmissionPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  submissionHeader: PropTypes.string.isRequired,
  submissionSubText: PropTypes.string.isRequired,
  submissionErrors: PropTypes.array.isRequired,
  loadingTitle: PropTypes.string,
  loadingMessage: PropTypes.string,
  ariaLoadingLabel: PropTypes.string,
};
